import { AppHeader } from '../../components/AppHeader';
import { HeroSection } from './HeroSection';
import { ProblemSection } from './ProblemSection';
import { GapSection } from './GapSection';
import { FeaturesSection } from './FeaturesSection';
import { FinalCTA } from './FinalCTA';
import { useIsMobile } from '../../hooks/useIsMobile';
import './LandingPage.css';

export function LandingPage() {
  const isMobile = useIsMobile();
  return (
    <div className="landing">
      {!isMobile && <AppHeader />}
      <HeroSection />
      <ProblemSection />
      <GapSection />
      <FeaturesSection />
      <FinalCTA />
    </div>
  );
}
